export default {"src":"/_next/static/media/forbes-logo.573ac97b.svg","height":26,"width":97,"blurWidth":0,"blurHeight":0};